<template>
  <div class="text" v-if="!getIsMobile">
    <p>You are already logged in as Company user</p>
    <p>Do you want to logout and login as Application user ?</p>
    <el-button type="primary" class="mt-1" @click="logoutUser">Logout</el-button>
  </div>
</template>
<script>
  import applicationUsersForbidden from '@/mixins/applicationUsersForbidden';
  import mobileRelatedHelper from '@/mixins/MobileRelatedHelper.js';
  import { mapGetters } from 'vuex';
  export default {
    name: 'ApplicationUsersForbidden',
    mixins: [applicationUsersForbidden, mobileRelatedHelper],
    computed: {
      ...mapGetters('navigationOpen', ['getIsMobile']),
    },
    mounted() {
      this.handleResize();
      if (this.getIsMobile) {
        this.logoutUser();
      }
    },
  };
</script>
<style scoped>
  .text {
    font-size: 18px;
    color: red;
    height: 100vh;
    margin-top: 30vh;
    text-align: center;
  }
</style>
